// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"icon-button-642","input":"input-064","cell":"cell-9fb","cellInput":"cell__input-2c0","tabSwitcher":"tab-switcher-311","tabSwitcherTab":"tab-switcher__tab-e27"};